import { createQueryKeys } from "@lukemorales/query-key-factory";
import { TrademarkListPayload } from "./records.types";

/**
 * Keys used to invalidate stored cached data regarding records module
 */
export const recordsKeys = createQueryKeys("records", {
  trademarkList: (filters: TrademarkListPayload) => ({
    queryKey: ["trademark_list", filters],
  }),
});
